import { IApplicationState } from '../../types/redux';

/**
 * Выбирает статьи на Главной
 */
export const selectMainArticles = ({ mainArticles }: IApplicationState) => mainArticles;
